/* ODDFISH TESTIMONIALS — slick slider, 3 dots, 6s auto-rotate (matches oddfishmedia.com.au) */

(function () {
  "use strict";

  var AUTOPLAY_MS = 6000;
  var MAX_WAIT_MS = 8000;

  function whenSlickReady(callback) {
    if (typeof jQuery !== "undefined" && jQuery.fn && jQuery.fn.slick) {
      callback();
      return;
    }

    var started = Date.now();
    var timer = setInterval(function () {
      if (typeof jQuery !== "undefined" && jQuery.fn && jQuery.fn.slick) {
        clearInterval(timer);
        callback();
        return;
      }

      if (Date.now() - started > MAX_WAIT_MS) {
        clearInterval(timer);
      }
    }, 50);
  }

  function refreshStrikes() {
    if (typeof window.oddfishHandleScrollReveal === "function") {
      window.oddfishHandleScrollReveal();
    }
  }

  function fixSlickHeight($slider) {
    if (!$slider.hasClass("slick-initialized")) return;

    $slider.find(".slick-list").css("height", "auto");
    $slider.find(".slick-track").css("height", "auto");
    $slider.find(".slick-slide").css("height", "auto");
  }

  function initSlider(section) {
    if (!section || !section.classList.contains("fifth_section_home")) return;

    var slider = section.querySelector(".oddfish-testimonial-slider");
    if (!slider) return;

    whenSlickReady(function () {
      var $slider = jQuery(slider);

      if ($slider.hasClass("slick-initialized")) {
        $slider.slick("unslick");
      }

      $slider.on("init afterChange", function () {
        fixSlickHeight($slider);
        refreshStrikes();
      });

      $slider.slick({
        dots: true,
        arrows: false,
        infinite: true,
        speed: 500,
        fade: false,
        cssEase: "linear",
        slidesToShow: 1,
        slidesToScroll: 1,
        autoplay: true,
        autoplaySpeed: AUTOPLAY_MS,
        pauseOnHover: true,
        pauseOnFocus: true,
        adaptiveHeight: false,
        accessibility: true
      });

      fixSlickHeight($slider);
      refreshStrikes();

      window.setTimeout(function () {
        fixSlickHeight($slider);
      }, 100);
    });
  }

  function bootAll(root) {
    var scope = root || document;
    scope.querySelectorAll(".oddfish-home-page.fifth_section_home").forEach(initSlider);
  }

  var resizeTimer;
  function handleResize() {
    window.clearTimeout(resizeTimer);
    resizeTimer = window.setTimeout(function () {
      document.querySelectorAll(".oddfish-home-page.fifth_section_home .oddfish-testimonial-slider.slick-initialized").forEach(function (slider) {
        fixSlickHeight(jQuery(slider));
        jQuery(slider).slick("setPosition");
      });
      refreshStrikes();
    }, 150);
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", bootAll);
  } else {
    bootAll();
  }

  window.addEventListener("load", function () {
    bootAll();
    refreshStrikes();
  });

  window.addEventListener("resize", handleResize, { passive: true });

  document.addEventListener("shopify:section:load", function (e) {
    bootAll(e.target);
    refreshStrikes();
  });
})();
